module.exports = __webpack_public_path__ + "static/media/payment.92d38015.svg";